<h2 mat-dialog-title style="margin-bottom: 20px">Payment confirmation</h2>


<mat-dialog-content>
    <form [formGroup]="paymentForm" style="margin-top:10px; display: flex; flex-direction: column; gap: 5px;">
        <div class="form-row">
            <mat-form-field appearance="outline" [style.width]="200">
                <mat-label>dd/MM/YYYY</mat-label>
                <input matInput [matDatepicker]="picker" formControlName="date">
                <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                <mat-datepicker #picker></mat-datepicker>
                @if (paymentForm.get('date')?.invalid ) {
                <mat-error>Invalid date</mat-error>
                }
            </mat-form-field>
        </div>
        <div class="form-row">
            <mat-form-field appearance="outline" style="width: 240px">
                <mat-label>Reference</mat-label>
                <input matInput type="text" formControlName="reference" style="width:300px">
                @if (paymentForm.get('reference')?.hasError('maxLength')) {
                <mat-error>Max. 64 characters</mat-error>
                }
            </mat-form-field>
        </div>
    </form>
</mat-dialog-content>
<mat-dialog-actions align="end">
    <button mat-button (click)="onCancel()">Cancel</button>
    <button mat-raised-button color="primary" (click)="onSave()" [disabled]="paymentForm.invalid">Save</button>
</mat-dialog-actions>